import AuthService from "../services/auth.service";
import Cookies from "js-cookie";
import axios from "axios";

export const BASE_URL = `${process.env.REACT_APP_PUBLIC_BASE_URL}`;

export const axiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

export const axiosAuthInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    Pragma: "no-cache",
  },
});

axiosAuthInstance.interceptors.request.use(
  function (config) {
    const userToken = Cookies.get("access_token");
    if (userToken) {
      config.headers["Authorization"] = `Bearer ${userToken}`;
      if (
        config.url === "/users/me/profile" ||
        config.url === "/biller-category" ||
        config.url === "/mail-templates"
      ) {
        config.headers["Content-Type"] = "multipart/form-data";
      }
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// createAuthRefreshInterceptor(axiosAuthInstance, AuthService.refreshToken);

axiosAuthInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    const currentUrl = window.location.href;

    if (error.response.status === 403) {
      AuthService.logout();
      window.location.href = `/login?return_url=${encodeURIComponent(
        currentUrl
      )}`;
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        await AuthService.refreshToken(error);
        const token = Cookies.get("access_token");

        if (!token) {
          AuthService.logout();
          window.location.href = `/login?return_url=${encodeURIComponent(
            currentUrl
          )}`;
        }
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        return axiosAuthInstance(originalRequest);
      } catch (err) {
        AuthService.logout();
        window.location.href = `/login?return_url=${encodeURIComponent(
          currentUrl
        )}`;
      }
    }
    return Promise.reject(error);
  }
);
